module.exports = __webpack_public_path__ + "static/img/logo_shjtdx.037b3cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_shjtdx.png
// module id = 9Gsn
// module chunks = 15